/**
 * The CMSBlock component
 */
import React, { Component } from "react";
import LpHeroFullsize from './utils/LpHeroFullsize';
import LpHeroWidget from './utils/LpHeroWidget';
import LpSeaProductHero from './utils/LpSeaProductHero';
import LpSeaProductList from './utils/LpSeaProductList';
import LpSeaProductGrid from './utils/LpSeaProductGrid';
import LpSeaTopicLp from './utils/LpSeaTopicLp';
import LpCMSContent from './utils/LpCMSContent';
import { push } from 'connected-react-router'
import { bindActionCreators } from 'redux'
import { connect } from "react-redux";


/**
 * Binds dispatch method to the actions passed as props to the component
 *
 */

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => bindActionCreators({
    navigateTo: push
  },
  dispatch
)

class LandingpageContent extends Component {

 render() {
   const {landingpage, navigateTo, cmsBlock1, productTeasers} = this.props;
  switch(landingpage.page_type) {
      case 'sea_product_hero':
        return <LpSeaProductHero {...this.props} />
      case 'sea_topic_lp':
        return <LpSeaTopicLp {...this.props} />
      case 'sea_product_list':
        return <LpSeaProductList {...this.props} />
      case 'sea_product_grid':
        return <LpSeaProductGrid {...this.props} />
      case 'hero_widget':
        return <LpHeroWidget {...this.props} />
      case 'cms_page':
        return <LpCMSContent {...this.props} />
      default:
        return <LpHeroFullsize landingpage={ landingpage } navigateTo={ navigateTo } cmsBlock1={cmsBlock1} productTeasers={productTeasers} />
    }
  }
}
export default connect(mapStateToProps, mapDispatchToProps)((LandingpageContent));